module.exports = __webpack_public_path__ + "static/img/30.67c9821b.png";